App.controller('NnwStartCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$stateParams', '$window', 'popUpService', function ($scope, $sce, $state, $http, packageService, $stateParams, $window, popUpService) {
    $scope.stateParams = $stateParams;

    $scope.page = 'nnw_start';
    $scope.$emit('page', $scope.page);

    $scope.step = 'NNW Szkolne';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.dashboard';
    $scope.$emit('link', $scope.link);

    if ($scope.stateParams.choose && $scope.stateParams.prices) {
        $scope.choose = $scope.stateParams.choose;
        $scope.prices = $scope.stateParams.prices;
        $scope.summary = $scope.stateParams.summary;
        $scope.persons = $scope.stateParams.persons;
    } else {
        $scope.summary = 0;
    }

    $scope.redirectToDlaSpokojuPl = function() {
        let dlaSpokojuPl = $scope.CONFIGURATOR.nnw.linkToDlaSpokojuPl;
        if (!dlaSpokojuPl) {
            $state.go('root.login');
            return false;
        }
        $window.location.href = dlaSpokojuPl;
    };

    $scope.allLength = 0;
    $scope.groupwidth = [];
    $scope.singleLength = [];

    $scope.next = function () {
        $state.go('root.nnw.start', {
            persons: $scope.persons,
            choose: $scope.choose,
            prices: $scope.prices,
            summary: $scope.summary
        });
    };

    // $scope.showNNWInfoPopUp = function() {
    //     return popUpService.showPopUp({
    //         content: 'Dalsza możliwość przystępowania do grupowego ubezpieczenia NNW Szkolne została wyłączona.<br/><br/>Polisy zawarte na rok 2020/2021 pozostają aktywne. Nowa oferta ubezpieczenia pojawi się przed rozpoczęciem roku szkolnego oraz akademickiego 2021/2022.',
    //         // hideButton: true,
    //         clickOutsideToClose: true
    //     });
    // };
    // $scope.showNNWInfoPopUp();
}]);
